<template>
    <div class="panel-body">
        <div class="ticket-form text-white">
            <template v-if="departments.length &&  regions.length && !loadingTicketsFields">
                <form @submit.prevent="create()" id="submit_ticket" action="/users/submit-ticket" method="post">
                    <div class="form-group col-xs-12 p-a-0 clearfix">
                        <div class="col-xs-12 col-sm-6"><div class="field-title">
                            <label for="region">Region</label>
                            <select v-model="region" class="form-control" name="region" id="region">
                                <option v-for="option in regions" v-bind:value="option.value">
                                    {{ option.name }}
                                </option>
                            </select>
                        </div>
                        </div>
                        <div class="form-group col-xs-12 col-sm-6">
                            <div class="field-title">
                                <label for="department">Department</label>
                                <select v-model="department" class="form-control" name="department" id="department">
                                    <option v-for="option in departments" v-bind:value="option.value">
                                        {{ option.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group col-xs-12 col-sm-6">
                            <div class="field-title">
                                <label for="subject">Subject*</label>
                                <input v-model="subject" class="form-control" type="text" name="subject" id="subject" placeholder="">
                            </div>
                        </div>
                        <div class="form-group col-xs-12 col-sm-6">
                            <div class="field-title">
                                <label for="product">Product*</label>
                                <input v-model="product" class="form-control" type="text" name="product" id="product" placeholder="">
                            </div>
                        </div>
                        <div class="form-group col-xs-12 col-sm-6">
                            <div class="field-title">
                                <label for="description">Description*</label>
                                <textarea v-model="description" class="form-control" name="description" id="description" placeholder="" style="max-width: 100% !important;"></textarea>
                            </div>
                        </div>
                        <div class="form-group col-xs-12 col-sm-6">
                            <div class="field-title">
                                <label for="attachment-input">Attachment</label>
                                <input @change="attachmentLoaded" class="form-control" type="file" name="attachment" id="attachment-input" multiple="multiple" placeholder="">
                            </div>
                        </div>
                    </div>

                    <button class="btn btn-sm btn-round btn-green pull-right" type="submit">SUBMIT <i class="fa fa-long-arrow-right" aria-hidden="true"></i></button>
                </form>
            </template>
            <template v-else>
                <div style="text-align:center">
                    <span class="fa fa-spin fa-spinner"></span>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CreateTicket",
        data() {
            return {
                region: "north_america",
                department: "bld_support",
                subject: "",
                product: "",
                description: "",
                attachment: "",
                departments: [],
                regions: [],
                loadingTicketsFields: true
            };
        },
        created() {
            this.getDepartments();
        },
        methods: {
            ticketFormData() {
                const formData = new FormData();
                formData.append("region", this.region);
                formData.append("department", this.department);
                formData.append("subject", this.subject);
                formData.append("product", this.product);
                formData.append("description", this.description);
                if ($("#attachment-input").get(0).files.length) {
                    formData.append("attachment", $("#attachment-input").get(0).files[0]);
                }

                return formData;
            },
            async create() {
                try {
                    let ticket = await axios({
                        url: "/tickets",
                        method: "POST",
                        data: this.ticketFormData()
                    });
                    this.$emit("reloadTickets");
                    this.clearFields();
                    this.goToTickets();
                } catch(error) {
                    toastr.error(error);
                }
            },
            attachmentLoaded(input) {},
            getDepartments() {
                axios({
                    url: "/ticket-fields-options/22478634",
                    method: "GET"
                }).then(departments => {
                    this.departments = departments.data;
                    this.getRegions();
                }).catch(error => {
                    this.loadingTicketsFields = false;
                    toastr.error(error);
                })
            },
            clearFields() {
                this.subject = "";
                this.product = "";
                this.description = "";
                this.region = "north_america";
                this.attachment = "";
            },
            getRegions() {
                axios({
                    url: "/ticket-fields-options/22491970",
                    method: "GET"
                }).then(regions => {
                    this.regions = regions.data;
                    this.loadingTicketsFields = false;
                }).catch(error => {
                    this.loadingTicketsFields = false;
                    toastr.error(error);
                })
            },
            goToTickets() {
                toastr.success("Your request was succesfully submitted");
                this.$router.push({ name: 'UserAccount', query: { currentTab: 'tickets'}});
            }
        }
    }
</script>
